<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>GST Master</b-navbar-brand>

          <!-- <b-button
            v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                "
            size="sm"
            class="ml-1"
            @click="getReports('GST_Location_List')"
            variant="outline-info"
          >Export</b-button> -->
          <b-button v-if="
              $sessionsStorage.get('designation') == 'Admin' &&
              $sessionsStorage.get('nameUser') == 'Bhavneesh'
            " :disabled="ExcelBtnName != 'Export' ? true : false" class="ml-3"
            @click="getReports('GST_Location_List', 'Export')" size="sm" variant="outline-info">{{ ExcelBtnName }}
            <b-spinner v-if="ExcelBtnName != 'Export'" small label="Small Spinner"></b-spinner></b-button>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12">
                  <h5>{{GSTMaster.stateId?'Update ':'Add '}} {{GSTMaster.stateName}} GST Details</h5>
                </b-col>
                <b-col md="3">
                  <label>
                    State Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="stateName" name="stateName"
                    v-model="GSTMaster.stateName"
                    :disabled="($sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh')?false:GSTMaster.stateId ?true:false"
                    placeholder="State Name"></b-form-input>
                  <span class="error" v-if="!GSTMaster.stateName">
                    {{
                    errorList.stateName
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    State Code
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="stateCode" name="stateCode"
                    v-model="GSTMaster.stateCode"
                    :disabled="($sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh')?false:GSTMaster.stateId ?true:false"
                    placeholder="State Code"></b-form-input>
                  <span class="error" v-if="!GSTMaster.stateCode">
                    {{
                    errorList.stateCode
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    GST Code
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="gstCode" name="gstCode"
                    v-model="GSTMaster.gstCode"
                    :disabled="($sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh')?false:GSTMaster.stateId ?true:false"
                    placeholder="State Code"></b-form-input>
                  <span class="error" v-if="!GSTMaster.gstCode">
                    {{
                    errorList.gstCode
                    }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Status :
                    <span class="error">*</span>
                  </label>
                  <md-switch :id="'approval'+GSTMaster.isActive" name="approval" class="md-primary"
                    :value="GSTMaster.isActive==true?true:false" @change="activateGSTMaster()">
                    <h6>
                      <b-badge
                        :variant="GSTMaster.isActive==1?'success':'danger'">{{GSTMaster.isActive==1?"Active":"In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addGSTMaster" class="mt-2"
                      id="addButtonLoader">
                      {{
                      GSTMaster.stateId ? "Update" : "Save"
                      }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search GST Master and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="MasterGSTList" :fields="fields" :current-page="currentPage"
                  :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection" @filtered="onFiltered" responsive primary-key="stateId"
                  class="position-relative">
                  <template slot="stateId" slot-scope="row0">
                    <span>
                      {{
                      row0.index + 1 + (currentPage - 1) * perPage
                      }}
                    </span>
                  </template>
                  <template slot="stateName" slot-scope="row1">
                    <span>{{ row1.item.stateName }}</span>
                  </template>
                  <template slot="stateCode" slot-scope="row1">
                    <span>{{ row1.item.stateCode }}</span>
                    <br />
                  </template>
                  <template slot="gstCode" slot-scope="row2">
                    <span>{{ row2.item.gstCode }}</span>
                  </template>
                  <template slot="isActive" slot-scope="row3">
                    <!-- <h6>
                      <b-badge
                        :variant="row3.item.isActive==1?'success':'danger'"
                      >{{row3.item.isActive==1?"Active":"In-Active" }}</b-badge>
                    </h6> -->

                    <div v-if="adminToggle == 'Admin'" :id="'row' + row3.item.stateId">
                      <md-switch :id="'approval' + row3.item.stateId" name="approval" class="md-primary"
                        :value="row3.item.isActive == 1 ? true : false" @change="activateUser(row3.item)">
                        <h6>
                          <br />
                          <b-badge style="margin-left: -45px">{{
                            row3.item.isActive == 1 ? "Active" : "In-Active"
                            }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row3.item.stateId">
                      <h6>
                        <b-badge>{{
                          row3.item.isActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                      </h6>
                    </div>

                  </template>
                  <template slot="creationTime" slot-scope="row3">{{row3.item.creationTime}}</template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editGSTLocation(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/gstMaster");
      if (globalPermissionStatus("GST Master") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("GST Master")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      this.getData();
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "stateId",
          label: "SN.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "stateName",
          label: "State Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "stateCode",
          label: "State Code",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "gstCode",
          label: "GST Code",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "creationTime",
          label: "Date",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      ExcelBtnName: "Export",
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get("designation"),
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      GSTMaster: {
        stateId: "",
        stateName: "",
        stateCode: "",
        gstCode: "",
        isActive: true,
        TypeofAdd: "GST Master Add"
      },
      GSTMasterError: [
        "Please Enter State Name",
        "Please Select State Code",
        "Please Enter GST COde"
      ],
      errorList: {
        stateName: "",
        stateCode: "",
        gstCode: ""
      },

      MasterGSTList: [],
      validate: true,

      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation")
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    getReports(id, btnName) {
      let payload = {
        excelId: id
      };
      this.ExcelBtnName= "Downloading Please Wait....";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        this.ExcelBtnName= btnName;
        ExcelName = this.$store.getters[
          "common/getAllPendingReverseTallyExcel"
        ];
        // alert(ExcelName)
        // if (ExcelName) {
        //   window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + ExcelName;
        // }
      }
    },
    clearErrVal() {
      this.GSTMaster = {
        stateId: "",
        stateName: "",
        stateCode: "",
        gstCode: "",
        isActive: true,
        TypeofAdd: "GST Master Add"
      };
      this.errorList = {
        stateName: "",
        stateCode: "",
        gstCode: ""
      };
    },

    editGSTLocation(item) {
      this.clearErrVal();
      this.addEditCard = true;
      item.TypeofAdd = "GST Master Add";
      this.GSTMaster = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function() {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    activateGSTMaster() {
      if (this.GSTMaster.isActive == 1 || this.GSTMaster.isActive == true) {
        this.GSTMaster.isActive = false;
      } else if (
        this.GSTMaster.isActive == 0 ||
        this.GSTMaster.isActive == false
      ) {
        this.GSTMaster.isActive = true;
      }
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getData("0", "0", "1", "1");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getData("0", "0", "1", "1");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },
    validateGSTMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.GSTMaster[x] == "" ||
          this.GSTMaster[x] == undefined ||
          this.GSTMaster[x] == null
        ) {
          this.errorList[x] = this.GSTMasterError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    addGSTMaster() {
      this.validateGSTMaster();
      this.GSTMaster.TypeofAdd = "GST Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;

      let payload = {
        itemCode: "add_GST_Details",
        GSTMaster: this.GSTMaster
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        CommonService.getAllProformaInvoice(payload)
          .then(response => {
            const { data, status, statusText } = response;
            if (data.stateId != "" && data.stateId != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.addEditCardFunc();
              this.getData();
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch(error => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },

    getData() {
      this.isLoading = true;
      let payload = {
        itemCode: "StateList"
      };
      CommonService.getAllProformaInvoice(payload)
        .then(response => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.MasterGSTList = data.StateList;
            this.totalRows = data.StateList.length;
            console.log(" GST Master List response=>", data);
          } else {
            this.MasterGSTList = [];
          }

          this.isLoading = false;
        })
        .catch(error => {
          console.log("Catch on GST Master List Error: ", error);
        });
    },

    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.stateId;

      this.itemObj.isActive = this.itemObj.isActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "statemaster",
        tableId: "stateId",
        tableIsActive: "isActive",
        value1: this.itemObj.isActive,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// gstMaster.vue?47338fdd